import React from "react";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import { useAppStore } from "../../store";
import { ConfigProvider } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
var SingleOutlet = function SingleOutlet(props) {
  var _props$layoutConfig$p;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var errorCaptureException = useAppStore(function (s) {
    return s.errorCaptureException;
  });
  var captureException = useAppStore(function (s) {
    var _s$monitorConfig;
    return (_s$monitorConfig = s.monitorConfig) === null || _s$monitorConfig === void 0 ? void 0 : _s$monitorConfig.captureException;
  });
  var errorFallback = ((_props$layoutConfig$p = props.layoutConfig.paneErrorBoundary) === null || _props$layoutConfig$p === void 0 ? void 0 : _props$layoutConfig$p.fallback) || void 0;
  var onError = errorCaptureException || props.layoutConfig.errorCaptureException || captureException;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    onError: onError,
    fallback: errorFallback,
    children: /*#__PURE__*/_jsx("div", {
      className: "__sa-page-target__single-outlet",
      children: /*#__PURE__*/_jsx(ConfigProvider, {
        getTargetContainer: function getTargetContainer() {
          return document.querySelector("__sa-page-target__single-outlet");
        },
        children: /*#__PURE__*/_jsx(Outlet, {})
      })
    })
  }, pathname);
};
export default SingleOutlet;